import React, { useState } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import Table from '../../components/ui/Table';
import Modal from '../../components/ui/Modal';
import { Select } from '../../components/ui/Input';
import { useToast } from '../../components/ui/Toast';
import { stockChecks } from '../../data/mockData';
import { Plus, Download } from 'lucide-react';

export default function Inventory() {
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);

  const columns = [
    {
      key: 'productName', label: 'Товар',
      render: (v, row) => (
        <div>
          <div style={{ fontWeight: 600, fontSize: 13 }}>{v}</div>
          <code style={{ fontSize: 11, color: '#8E8E93' }}>{row.barcode}</code>
        </div>
      )
    },
    { key: 'systemQuantity', label: 'Сист. кол-во', render: v => <span style={{ color: '#6B7280' }}>{v}</span> },
    {
      key: 'actualQuantity', label: 'Факт. кол-во',
      render: (v, row) => (
        <span style={{ fontWeight: 700, color: v === row.systemQuantity ? '#34C759' : '#FF3B30' }}>
          {v}
        </span>
      )
    },
    {
      key: 'actualQuantity', label: 'Расхождение',
      render: (v, row) => {
        const diff = v - row.systemQuantity;
        return diff === 0
          ? <span style={{ color: '#34C759', fontWeight: 700 }}>0</span>
          : <span style={{ fontWeight: 700, color: diff < 0 ? '#FF3B30' : '#FF9500' }}>{diff > 0 ? `+${diff}` : diff}</span>;
      }
    },
    { key: 'unit', label: 'Ед.', render: v => <span style={{ color: '#6B7280' }}>{v}</span> },
    { key: 'status', label: 'Статус', render: v => <Badge variant={v === 'confirmed' ? 'success' : v === 'corrected' ? 'in_progress' : 'pending'}>{v === 'confirmed' ? '✓ Подтверждено' : v === 'corrected' ? '↻ Скорректировано' : '⏳ Ожидает'}</Badge> },
    { key: 'scheduledDate', label: 'Дата проверки', render: v => <span style={{ fontSize: 12, color: '#6B7280' }}>{v}</span> },
    { key: 'note', label: 'Примечание', render: v => <span style={{ fontSize: 12, color: '#8E8E93', fontStyle: v ? 'normal' : 'italic' }}>{v || '—'}</span> },
    {
      key: 'actions', label: '', sortable: false,
      render: (_, row) => row.status === 'pending' ? (
        <div style={{ display: 'flex', gap: 6 }} onClick={e => e.stopPropagation()}>
          <button onClick={() => toast('Подтверждено', 'success')} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #34C759', background: '#F0FFF4', cursor: 'pointer', color: '#34C759', fontFamily: 'inherit' }}>Подтвердить</button>
          <button onClick={() => toast('Скорректировано', 'success')} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #4A6CF7', background: '#EEF2FF', cursor: 'pointer', color: '#4A6CF7', fontFamily: 'inherit' }}>Скорректировать</button>
        </div>
      ) : null
    }
  ];

  const discrepancies = stockChecks.filter(s => s.actualQuantity !== s.systemQuantity).length;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Инвентаризация</h1>
          <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Проверки остатков и расхождения</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button variant="secondary" icon={<Download size={14} />} onClick={() => toast('Экспорт расхождений', 'success')}>Экспорт</Button>
          <Button icon={<Plus size={14} />} onClick={() => setShowModal(true)}>Создать инвентаризацию</Button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
        {[
          { label: 'Всего позиций', value: stockChecks.length, color: '#4A6CF7', bg: '#EEF2FF' },
          { label: 'Расхождений', value: discrepancies, color: '#FF3B30', bg: '#FFF0F0' },
          { label: 'Подтверждено', value: stockChecks.filter(s => s.status === 'confirmed').length, color: '#34C759', bg: '#F0FFF4' },
        ].map(s => (
          <div key={s.label} style={{ background: s.bg, borderRadius: 12, padding: '16px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 800, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 12, color: '#6B7280' }}>{s.label}</div>
          </div>
        ))}
      </div>

      <Card padding="0"><Table columns={columns} data={stockChecks} emptyText="Нет данных инвентаризации" /></Card>

      <Modal open={showModal} onClose={() => setShowModal(false)} title="Создать инвентаризацию">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Select label="Тип" options={[{ value: 'products', label: 'Конкретные товары' }, { value: 'category', label: 'По категории' }, { value: 'store', label: 'Весь магазин' }]} placeholder="Выберите тип" />
          <Select label="Магазин" options={[{ value: 's1', label: 'Магазин Чиланзар' }, { value: 's2', label: 'Магазин Юнусабад' }]} placeholder="Выберите магазин" />
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Отмена</Button>
            <Button onClick={() => { toast('Инвентаризация создана', 'success'); setShowModal(false); }}>Создать</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
